// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function requesterDetails_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var phone = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "phone"), null));
    if (phone.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                phone: phone._0
              }
            };
    }
    var e = phone._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".phone" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function requester_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var user_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "user_id"), null));
  if (user_id.TAG === /* Ok */0) {
    var persona = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "persona"), null));
    if (persona.TAG === /* Ok */0) {
      var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var phone = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "phone"), null));
        if (phone.TAG === /* Ok */0) {
          var details = Decco.optionFromJson(requesterDetails_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "details"), null));
          if (details.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      user_id: user_id._0,
                      persona: persona._0,
                      name: name._0,
                      phone: phone._0,
                      details: details._0
                    }
                  };
          }
          var e = details._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".details" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = phone._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".phone" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = persona._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".persona" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = user_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".user_id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function order_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_uuid"), null));
  if (order_uuid.TAG === /* Ok */0) {
    var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
    if (status.TAG === /* Ok */0) {
      var crm_status = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crm_status"), null));
      if (crm_status.TAG === /* Ok */0) {
        var geo_region_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
        if (geo_region_id.TAG === /* Ok */0) {
          var total_amount_minor = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_amount_minor"), null));
          if (total_amount_minor.TAG === /* Ok */0) {
            var currency_code = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_code"), null));
            if (currency_code.TAG === /* Ok */0) {
              var customer = Decco.optionFromJson(requester_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer"), null));
              if (customer.TAG === /* Ok */0) {
                var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
                if (created_at.TAG === /* Ok */0) {
                  var updated_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
                  if (updated_at.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              order_uuid: order_uuid._0,
                              status: status._0,
                              crm_status: crm_status._0,
                              geo_region_id: geo_region_id._0,
                              total_amount_minor: total_amount_minor._0,
                              currency_code: currency_code._0,
                              customer: customer._0,
                              created_at: created_at._0,
                              updated_at: updated_at._0
                            }
                          };
                  }
                  var e = updated_at._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".updated_at" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = created_at._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".created_at" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = customer._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".customer" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = currency_code._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".currency_code" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = total_amount_minor._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".total_amount_minor" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = geo_region_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".geo_region_id" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = crm_status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".crm_status" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = status._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".status" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = order_uuid._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_uuid" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var orders = Decco.arrayFromJson(order_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "orders"), null));
  if (orders.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              orders: orders._0
            }
          };
  }
  var e = orders._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".orders" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  requesterDetails_decode ,
  requester_decode ,
  order_decode ,
  t_decode ,
  
}
/* No side effect */
